export const CANCEL = 'cancel';
export const MESSAGEUS = 'messageus';
export const CLOSE = 'close';
export const EMPTY_RESPONSE = 'Empty Response';
export const TPM = 'TPM';
